var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { connect } from 'react-redux';
import { loadAllScenarioFileNames, scenarioFileRead, scenarioSelectionChanged } from './actions';
import Select from 'material-ui/Select/Select';
import MenuItem from 'material-ui/Menu/MenuItem';
import Button from 'material-ui/Button/Button';
import Grid from 'material-ui/Grid/Grid';
import { FormControl } from 'material-ui';
var TestController = /** @class */ (function (_super) {
    __extends(TestController, _super);
    function TestController() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleTestCaseChoose = function (event) {
            _this.props.scenarioSelectionChanged(event.target.value);
        };
        _this.onTestFileReadClicked = function (event) {
            _this.props.scenarioFileRead(_this.props.scenarioState.selectedScenarioId);
        };
        return _this;
    }
    TestController.prototype.componentDidMount = function () {
        this.props.loadAllScenarioFileNames();
    };
    TestController.prototype.render = function () {
        var scenarioPlay = this.props.scenarioPlay;
        var _a = this.props.scenarioState, selectedScenarioId = _a.selectedScenarioId, _b = _a.scenarioFiles, list = _b.list, loading = _b.loading;
        return (React.createElement("div", { style: { paddingTop: 20, paddingLeft: 20 } },
            React.createElement(Grid, { container: true },
                React.createElement(Grid, { item: true, xs: 6 },
                    React.createElement("span", null, "Test File")),
                React.createElement(Grid, { item: true, xs: 12 },
                    React.createElement(FormControl, { fullWidth: true },
                        React.createElement(Select, { value: selectedScenarioId, onChange: this.handleTestCaseChoose, autoWidth: true },
                            React.createElement(MenuItem, { value: "" },
                                React.createElement("em", null, "Choose a test file")),
                            !loading && list.map(function (value, index) { return (React.createElement(MenuItem, { key: index, value: value.name }, value.name)); })))),
                React.createElement(Grid, { item: true, xs: 3 },
                    React.createElement(Button, { variant: "raised", color: 'primary', onClick: this.onTestFileReadClicked, disabled: !selectedScenarioId || scenarioPlay }, "Read")))));
    };
    return TestController;
}(React.Component));
export default connect(function (_a) {
    var scenarioState = _a.scenarioState, scenarioPlay = _a.scenarioPlay;
    return ({ scenarioState: scenarioState, scenarioPlay: scenarioPlay });
}, { loadAllScenarioFileNames: loadAllScenarioFileNames, scenarioSelectionChanged: scenarioSelectionChanged, scenarioFileRead: scenarioFileRead })(TestController);



//////////////////
// WEBPACK FOOTER
// ./src/containers/TestController/index.tsx
// module id = 1820
// module chunks = 0